import { create } from 'zustand';

type Role = 'ADMIN' | 'PROCURER' | 'SUPPLIER';
export interface User {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  organisationName: string;
  organisationType: string;
  role: Role;
  status: string;
  createdAt: string;
  updatedAt: string;
  // resetPasswordToken: string | null;
  // resetPasswordExpiry: string | null;
  completedSteps?: string[];
}

export interface UserStore {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
  setUser: (user: User | null) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setLoading: (isLoading) => set({ isLoading }),
  clearUser: () => set({ user: null }),
}));
